import * as Sentry from '@sentry/react';
import axios from 'axios';
import { parse as cookieParse } from 'cookie';
import { RouterProvider, createBrowserRouter } from 'react-router';

import { AuthProvider } from '@/js/context/AuthContext';

// CSRF setup for Django
const { csrftoken } = cookieParse(document.cookie);
if (csrftoken) {
  axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
}

const router = createBrowserRouter([
  {
    path: '/login',
    lazy: () => import('./pages/auth/Login').then(m => ({ Component: m.default })),
  },
  {
    path: '/register',
    lazy: () => import('./pages/auth/Register').then(m => ({ Component: m.default })),
  },
  {
    path: '/',
    lazy: () => import('./layouts/AppLayout').then(m => ({ Component: m.default })),
    children: [
      {
        index: true,
        lazy: () => import('./pages/Dashboard').then(m => ({ Component: m.default })),
      },
      {
        path: 'tenants/new',
        lazy: () => import('./pages/tenants/NewTenant').then(m => ({ Component: m.default })),
      },
      {
        path: 'tenants/:tenantId',
        lazy: () => import('./pages/tenants/TenantDetail').then(m => ({ Component: m.default })),
      },
      {
        path: 'tenants/:tenantId/sites/new',
        lazy: () => import('./pages/sites/NewSite').then(m => ({ Component: m.default })),
      },
      {
        path: 'sites/:siteId',
        lazy: () => import('./pages/sites/SiteDetail').then(m => ({ Component: m.default })),
      },
      {
        path: 'api-keys',
        lazy: () => import('./pages/apikeys/ApiKeysPage').then(m => ({ Component: m.default })),
      },
      {
        path: 'admin/api-logs',
        lazy: () => import('./pages/apilogs/ApiLogsPage').then(m => ({ Component: m.default })),
      },
    ],
  },
  {
    path: '/invites/:token',
    lazy: () => import('./pages/invites/AcceptInvite').then(m => ({ Component: m.default })),
  },
  {
    path: '/',
    lazy: () => import('./layouts/EditorLayout').then(m => ({ Component: m.default })),
    children: [
      {
        path: 'sites/:siteId/onboarding',
        lazy: () => import('./pages/sites/OnboardingScreen').then(m => ({ Component: m.default })),
      },
      {
        path: 'sites/:siteId/posts/new',
        lazy: () => import('./pages/posts/PostEditor').then(m => ({ Component: m.default })),
      },
      {
        path: 'posts/:postId/edit',
        lazy: () => import('./pages/posts/PostEditor').then(m => ({ Component: m.default })),
      },
      {
        path: 'sites/:siteId/pages/new',
        lazy: () => import('./pages/pages/PageEditor').then(m => ({ Component: m.default })),
      },
      {
        path: 'pages/:pageId/edit',
        lazy: () => import('./pages/pages/PageEditor').then(m => ({ Component: m.default })),
      },
      {
        path: 'pages/:pageId/edit-content',
        lazy: () => import('./pages/sites/EditorModeView').then(m => ({ Component: m.default })),
      },
      {
        path: 'sites/:siteId/cms-posts/new',
        lazy: () => import('./pages/sites/cms/CmsPostEditor').then(m => ({ Component: m.default })),
      },
      {
        path: 'sites/:siteId/cms-posts/:postId/edit',
        lazy: () => import('./pages/sites/cms/CmsPostEditor').then(m => ({ Component: m.default })),
      },
    ],
  },
]);

const App = () => (
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </Sentry.ErrorBoundary>
);

export default App;
